export default {
  seo: {
    home: {
      title: 'Artemida Studio — Soluciones digitales creativas',
      description:
        'Creamos sitios web a medida de cualquier complejidad: páginas de destino, sitios corporativos y asistentes de IA.',
      keywords: 'desarrollo web, página de destino, sitio corporativo, IA',
    },
  },

  header: {
    homeLink: 'Inicio',
    aboutUsLink: 'Sobre nosotros',
    servicesLink: 'Servicios',
    ourProjectsLink: 'Nuestros proyectos',
    contact: 'Contacto',
    blogLink: 'Blog',
  },
  heroSection: {
    companyDescription: 'Creamos sitios web a medida de cualquier complejidad',
    contactUs: 'Contáctanos',
  },
  aboutUsSection: {
    aboutUsTitle: 'Sobre nosotros',
    aboutUsDescription:
      'En Artemida Studio nos especializamos en crear landing pages y sitios corporativos a medida que ayudan a las empresas a fortalecer su presencia en línea. Nuestra misión es ofrecer soluciones modernas, funcionales y visualmente impactantes, adaptadas a las necesidades de tu marca.\n\n' +
      'Combinando creatividad, las últimas tecnologías y un enfoque personalizado, construimos sitios que no solo son atractivos, sino también rápidos, fáciles de usar y completamente responsivos.\n\n' +
      'Tanto si necesitas una landing page de alta conversión como un sitio corporativo profesional, Artemida Studio está aquí para hacer realidad tu visión con soluciones a medida de alta calidad.\n\n' +
      'Elige profesionalismo y creatividad: ¡construyamos juntos tu sitio web perfecto!',
  },

  // Servicios (toda la sección controlada por i18n)
  services: {
    ourServices: 'Nuestros servicios',
    servicesDescription:
      'Nos especializamos en crear soluciones digitales personalizadas y de alta calidad para impulsar tu negocio',
    contactUs: 'Contáctanos',
    items: [
      {
        key: 'landing',
        title: 'Página \n de destino',
        descriptionList: [
          'Una página de destino bien diseñada es una herramienta poderosa para atraer clientes, aumentar las conversiones y reforzar la presencia online de tu marca. En Artemida Studio creamos landing pages personalizadas de alta calidad, alineadas con los objetivos de tu negocio.',
          '✔️ Diseño moderno y único — Páginas visualmente impactantes y alineadas con tu marca.',
          '✔️ Alta tasa de conversión — Estructuras optimizadas y CTAs convincentes para impulsar el engagement.',
          '✔️ Rápida y responsive — Rendimiento ultrarrápido y experiencia fluida en todos los dispositivos.',
          '✔️ Lista para SEO y marketing — Construida con buenas prácticas para mejorar la visibilidad y atraer tráfico orgánico.',
          '✔️ Totalmente personalizable — Cada detalle adaptado a tus necesidades y a la identidad de tu marca.',
        ],
      },
      {
        key: 'corporate',
        title: 'Sitio \n corporativo',
        descriptionList: [
          'Un sitio corporativo profesional es esencial para generar confianza, mostrar tu marca y conectar con los clientes. En Artemida Studio desarrollamos sitios corporativos a medida que reflejan los valores de tu empresa y te destacan en el mundo digital.',
          '✔️ Diseño profesional y único — Estilo moderno y cuidado, alineado con tu identidad de marca.',
          '✔️ Totalmente personalizable — Cada elemento pensado para tus objetivos y necesidades.',
          '✔️ Rápido y seguro — Optimizado para velocidad, seguridad y un rendimiento impecable.',
          '✔️ SEO y marketing friendly — Desarrollado siguiendo las mejores prácticas para aumentar la visibilidad y atraer clientes potenciales.',
          '✔️ Móvil y fácil de usar — Diseño totalmente responsive para una experiencia consistente en todos los dispositivos.',
          '✔️ Gestión de contenidos sencilla — Actualizaciones fáciles con un CMS intuitivo.',
        ],
      },
      {
        key: 'ai',
        title: 'Integración de asistentes IA',
        descriptionList: [
          '¡Potencia tu sitio con la IA! En Artemida Studio integramos asistentes de IA avanzados que mejoran la experiencia del usuario, automatizan tareas y aumentan el engagement. Ya sea un chatbot inteligente, soporte automatizado o recomendaciones impulsadas por IA, creamos soluciones a medida para tu negocio.',
          '✔️ Soporte al cliente 24/7 — Chatbots impulsados por IA atienden consultas en cualquier momento, mejorando la satisfacción.',
          '✔️ Integración transparente en el sitio — Funciona de forma fluida dentro de tu web, mejorando funcionalidades sin interrupciones.',
          '✔️ Experiencia personalizada — Interacciones guiadas por IA adaptadas a necesidades y preferencias del usuario.',
          '✔️ Generación de leads y aumento de ventas — Involucra visitantes, capta contactos y guía a los clientes hacia la compra.',
          '✔️ Automatización y eficiencia — Optimiza procesos, reduce carga de trabajo y tiempos de respuesta.',
          '✔️ Soluciones de IA a medida — Completamente adaptables a tu modelo de negocio y requisitos específicos.',
        ],
      },
    ],
  },
  contactSection: {
    title: 'Hablemos de tu proyecto',
    placeholderName: 'Nombre',
    placeholderPhone: 'Teléfono',
    placeholderEmail: 'Correo electrónico',
    placeholderMessage: 'Cuéntanos sobre tu proyecto',
    sendButton: 'Enviar',
  },
};
